import $ from 'jquery'
import { lockBody, unlockBody } from './functions'

$('.header-brands__text').on('click', function () {
  $(this).parent().toggleClass('header-brands--active')
  $('.header-brands__logos').slideToggle(250)
})

const openMenu = () => {
  lockBody()
  const body = document.body
  body.classList.add('menu-active')
}

const closeMenu = () => {
  const body = document.body
  body.classList.remove('menu-active')

  setTimeout(() => unlockBody(), 250)
}

const toggleMenu = () => {
  const body = document.body

  if (body.classList.contains('menu-active')) {
    closeMenu()
  } else {
    openMenu()
  }
}

$(document).on('click', function (e) {
  if ($(e.target).closest('.header-brands').length === 0) {
    $('.header-brands').removeClass('header-brands--active')
    $('.header-brands__logos').slideUp(250)
  }
})

$('.menu-toggle').on('click', toggleMenu)

$('.site-nav-wrapper, .site-nav-inner').on('click', function (e) {
  if (e.target === e.currentTarget) {
    closeMenu()
  }
})

$(document).keyup(function (e) {
  if (e.key === 'Escape') {
    closeMenu()
  }
})

const menu = document.querySelector('.main-navigation')
const setMenuPos = () => {
  if (!menu) {
    return
  }

  if (window.matchMedia('(max-width: 1920px)').matches) {
    menu.style.right = ''
    return
  }

  const main = document.getElementById('primary')

  const windowWidth = document.body.offsetWidth
  const mainWidth = main.clientWidth

  const diff = windowWidth - mainWidth

  menu.style.right = `${diff / 2 - 5}px`
}

// setMenuPos()
// window.addEventListener('load', setMenuPos)
// window.addEventListener('resize', setMenuPos)
